
































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import InputSelect from '@/components/Inputs/InputSelect'
import { FormInputType } from '@/contracts/FormInputType'
import {
  IBlockProgressionSelect,
  SelectProgression,
} from '@/contracts/IBlockProgressionSelect'

@Component
class BlockProgressionSelect
  extends mixins(SectionCore)
  implements IBlockProgressionSelect
{
  @Prop() readonly id: string = ''
  @Prop() readonly idMaster: string = ''
  @Prop({ default: 'model' }) readonly parentStateVarName: string = 'model'
  @Prop() readonly labelFirst: string = ''
  @Prop() readonly labelSecond: string = ''
  @Prop() readonly type: FormInputType = FormInputType.Text
  @Prop() readonly placeholderFirst: string = ''
  @Prop() readonly placeholderSecond: string = ''
  @Prop() readonly noResultText: string = ''
  @Prop() readonly error: boolean | string = false
  @Prop() readonly rules: ReadonlyArray<string> = []
  @Prop() readonly SelectsProgression: ReadonlyArray<SelectProgression> = []
  @Prop() readonly useBorder: boolean = false
  static options: any
}

export default defineComponent({
  name: 'BlockProgressionSelect',
  components: {
    InputSelect,
  },
  props: BlockProgressionSelect.options.props,
  setup(
    { SelectsProgression, parentStateVarName, idMaster, id },
    { emit, parent }
  ) {
    const master = ref<any>([])
    const slave = ref<any>(null)
    const parentRoot = ref<any>(null)
    const parentModel = ref<any>(null)
    const options = ref<any>(SelectsProgression)

    const init = () => {
      let par = parent
      while (par) {
        if (par[parentStateVarName]) {
          parentRoot.value = par.$root
          parentModel.value = par[parentStateVarName]
          par = false
        } else {
          par = par.$parent ?? false
        }
      }
      if (parentModel.value[idMaster]) {
        Array.isArray(options.value) &&
          options.value.forEach((item) => {
            if (item.name === parentModel.value[idMaster]) {
              master.value = item.value
              master.value.forEach((it) => {
                if (it.value === parentModel.value[id]) slave.value = it.value
              })
            }
          })
      }
    }

    const onInputChangeMaster = (evt) => {
      master.value = evt
      slave.value = null
      emit('input-change', evt)
      Array.isArray(options) &&
        options.forEach((it) => {
          if (it.value === evt)
            parentRoot.value.$set(parentModel.value, idMaster, it.name)
        })
    }

    const onInputChangeSlave = (evt) => {
      slave.value = evt
      emit('input-change', evt)
    }

    const getLabel = (label, rules = []) => {
      return Array.isArray(rules) && rules.includes('required')
        ? label + '<span class=red-text>*</span>'
        : label
    }

    const onFocused = () => {
      emit('focused')
    }

    init()

    return {
      master,
      slave,
      parentRoot,
      parentModel,
      options,
      onInputChangeMaster,
      onInputChangeSlave,
      getLabel,
      onFocused,
    }
  },
})
